import { ReportVM } from "./ReportVM";

export class GenerateReportDto {
    ReportId: number;
    ReportName: string;
    ReportCode: string;
    SavedReportId: number;
    ReportFilters: string;
    defaultDateFormat :string;
}
export class GenerateReportMainDto {
    Instance: string;
    StartDate: Date;
    EndDate: Date;
    Weekly: boolean;
    IncludeMERABooking: boolean;
   
    Resources: SearchType3[];
    IncludeDummyResources: boolean;
    ResourceServiceLine: SearchType1[];
    ResourceSubServiceLine: SearchType1[];
    ResourceCompetency: SearchType1[];
    ResourceCountry: SearchType1[];
    ResourceCostCenter: SearchType1[];
    ResourceCompanyCode: SearchType1[];
    ResourceEconomicLocation: SearchType1[];
    ResourceOfficeLocation: SearchType1[];
    ResourceLevel: SearchType1[];
    ResourceGrade: SearchType1[];
    ResourceRank: SearchType1[];
    ResourceEmployeeStatus: SearchType1[];
    ResourceEmployeeType: SearchType1[];
    ResourceEmployeeDepartment: SearchType1[];
    ResourceGDSRegionAlignment: SearchType1[];
    ResourceCounsellors: SearchType1[];
    ResourceAvailability: number;
    ResourceFSO: boolean;
    ResourceRegion: SearchType1[];
    ResourceSubRegion: SearchType1[];

    Engagements: SearchType3[];
    IncludeDummyEngagement: boolean;
    EngagementType: SearchType1[];
    EngagementSubType: SearchType1[];
    EngagementServiceLine: SearchType1[];
    EngagementSubServiceLine: SearchType1[];
    EngagementCompetency: SearchType1[];
    EngagementRegion: SearchType1[];
    EngagementCountry: SearchType1[];
    EngagementCostCenter: SearchType1[];
    EngagementStatus: SearchType1[];
    EngagementCustomerIndustry: SearchType1[];
    EngagementCustomerPriorityStatus: SearchType1[];
    EngagementManagers: SearchType3[];
    EngagementPartners: SearchType3[];
    EngagementCustomers: SearchType3[];
    EngagementUltimateCustomers: SearchType1[];

    OtherBookingCategories: SearchType1[];
    OtherBookingTypes: SearchType1[];
    OtherBookings: SearchType3[];
    OtherMERAActions: SearchType1[];
    OtherMERABookings: SearchType3[];
    OtherRequestors: SearchType1[];
    OtherRequestorModes: SearchType1[];
    OtherStatus: SearchType1[];
    OtherStatusInformation: SearchType1[];
    OtherSubmittedBy: SearchType1[];
    OtherSubmittedOnStartDate: Date | null;
    OtherSubmittedOnEndDate: Date | null;
    OtherApprovedBy: SearchType1[];
    OtherApprovedOnStartDate: Date | null;
    OtherApprovedOnEndDate: Date | null;
    OtherRejectedBy: SearchType1[];
    OtherRejectedOnStartDate: Date | null;
    OtherRejectedOnEndDate: Date | null;

    isEmailRequired: boolean;
}

export class SearchType1 {
    ID: number;
    Text: string;
}
// export class SearchType2 {
//     ID: number;
//     Text: string;
// }
export class SearchType3 {
    ID: number;
    instanceId: number;
    Text: string;
}
export class GenerateReportInputDto {
    base64string: string;
}
export class DownloadReportInputDto {
    base64string: string;
}
export class DownloadReportDto {
    reportFileName: string;
    queuedReportId: number;
}
